import { AFTER_MUTATION } from "./afterMutation";
import { invalidateDepositRecordViews } from "./depositRecordQueries";
import { invalidateVolumeViews } from "../hooks/usePeriodicalVolumes";
import { PERIODICAL_LIBRARY_DETAIL_KEY } from "../hooks/usePeriodicalLibraryActions";
export var TITLE_AGENDA_KEY = "title-agenda";
export var TITLE_AGENDA_HISTORY_KEY = "title-agenda-history";
export var ISSUE_AGENDA_KEY = "issue-agenda";
export var TITLE_ENFORCEMENT_DETAIL_KEY = "title-enforcement-detail";
export var LINKABLE_PERIODICALS_KEY = "linkable-periodicals";
export var LINKABLE_VOLUMES_KEY = "linkable-volumes";
export var LINKABLE_ISSUES_KEY = "linkable-issues";
// An agenda change moves rows between both departments' lists and rebuilds the library's copies,
// so every view that shows either side is refreshed from one place.
export var invalidateAgendaViews = function (queryClient) {
    [
        [TITLE_AGENDA_KEY],
        [TITLE_AGENDA_HISTORY_KEY],
        [ISSUE_AGENDA_KEY],
        ["title"],
        [TITLE_ENFORCEMENT_DETAIL_KEY],
        ["titlesWithIsbn"],
        ["titlesWithoutIsbn"],
        ["titlesForVerification"],
        ["periodicalLibraries"],
        [PERIODICAL_LIBRARY_DETAIL_KEY],
        [LINKABLE_VOLUMES_KEY],
        [LINKABLE_ISSUES_KEY],
    ].forEach(function (key) {
        return queryClient.invalidateQueries(key, undefined, AFTER_MUTATION);
    });
    invalidateVolumeViews(queryClient);
    invalidateDepositRecordViews(queryClient);
};
